const PAUSED_STATUS = 1;
const PAID_STATUS = 2;
const NOT_APPROVED_STATUS = 3;
const PLANNED_STATUS = 4;
const LOCKED_STATUS = 5;

export default {
  PAUSED_STATUS,
  PAID_STATUS,
  NOT_APPROVED_STATUS,
  PLANNED_STATUS,
  LOCKED_STATUS
};



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/salaries/salary-payment-status-constants.js
 **/